<script>
	import { validator } from "../validation";
	import { projectSettings } from "../config/index";

	import { tick } from "svelte";
	import { get } from "svelte/store";

	export let id = null;
	export let label = null;
	export let sublabel = null;
	export let email = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
	export let validatorTarget = "#" + id + "_error";

	const authorization = `Basic ${projectSettings.loqateCredentials}`;

	let inputEl; // bound to the <input>
	let debounceTimer;
	let isValidating = false;
	let validated = false;
	let isValid = !!email.EmailAddress;
	let retryCount = 0;
	let retryLimit = 2;
	let valueOnFocus = null;
	let wasInvalidOnFocus = false;
	let isBlurring = false;

	$: email.EmailAddress = email.EmailAddress ? email.EmailAddress.toLowerCase() : email.EmailAddress;

	function handleInput(event) {
		// if (!validated) return;

		// clearTimeout(debounceTimer);
		// debounceTimer = setTimeout(() => {
		// 	handleChange(event);
		// }, 500);
	}

	async function validateEmailDomain(emailValue) {
		if (!emailValue) {
			return { success: true };
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(emailValue)) {
			return { success: false }; // invalid email format
		}

		const url = "https://hosted.mastersoftgroup.com/harmony/rest/au/validate/email";
		const data = {
			payload: [{ address: emailValue }],
			sourceOfTruth: "VE_ALL",
			featureOptions: { timeout: "1500" }
		};

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: authorization
			},
			body: JSON.stringify(data)
		};

		try {
			const response = await fetch(url, options);
			const responseData = await response.json();
			const { payload } = responseData;
			const [{ reason = [] } = {}] = payload || [];
			const allowedReasons = [
				"mailbox_is_role_address",
				"unknown_provider",
				"immature_domain",
				"req_timeout",
				"smtp_timeout"
			];
			const disallowedReasons = reason.filter((r) => !allowedReasons.includes(r));
			const isValid = disallowedReasons.length === 0;
			retryCount = 0;

			return { success: isValid };
		} catch {
			if (retryCount++ >= retryLimit) {
				return { timeout: true };
			} else {
				return validateEmailDomain(emailValue);
			}
		}
	}

	function showValidationError() {
		console.log("showing validation error");
		isValid = false;
		validated = true;
		// Trigger validator without dispatching change event to avoid handleChange
		setTimeout(() => {
			$validator.validate(inputEl);
		}, 0);
	}

	function handleFocus() {
		valueOnFocus = email.EmailAddress;
		wasInvalidOnFocus = !isValid;
		isValid = true;
		validated = false;
		isBlurring = false;
	}

	function handleBlur(e) {
		isBlurring = true;
		const valueChanged = email.EmailAddress !== valueOnFocus;

		if (valueChanged) {
			handleChange(e);
		} else if (wasInvalidOnFocus) {
			console.log("Value unchanged but was invalid on focus, showing validation error");
			showValidationError();
		}

		// setTimeout(() => {
		// 	isBlurring = false;
		// }, 0);
	}

	async function handleChange(e) {
		if (e && !e.isTrusted) return;
		if (isBlurring && e?.type === "change") return;

		validated = true;
		isValid = false;

		email.ThirdPartyValidated = false;
		$validator.clearVisualError(inputEl); // Clear existing error message
		isValidating = true; // Set validating state

		const emailValue = (e?.target?.value || email.EmailAddress || "").trim();

		if (!emailValue) {
			await tick();
			isValidating = false; // Reset validating state
			inputEl.dispatchEvent(new Event("change", { bubbles: true }));
			return;
		}

		try {
			let status = await validateEmailDomain(emailValue);
			isValid = status.success || status.timeout;
			email.ThirdPartyValidated = status.success;
			email.ValidationVendor = email.ThirdPartyValidated ? "Loqate" : null;
			await tick();
		} catch {
			email.ThirdPartyValidated = false;
			email.ValidationVendor = null;
			await tick();
		} finally {
			isValidating = false; // Ensure validating state is reset
			inputEl.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}
</script>

{#if label}
	<label for={id}>
		{label}
		{#if required}
			<span class="required">*</span>
		{/if}
		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}

<input
	bind:this={inputEl}
	{id}
	class="form-control"
	type="email"
	data-validator="emailinput"
	emailinput
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	bind:value={email.EmailAddress}
	on:input={handleInput}
	on:focus={handleFocus}
	on:blur={handleBlur}
	data-bouncer-target={validatorTarget}
	data-isvalid={isValid} />

<div id="{id}_error" class="email-input-error">
	{#if isValidating}
		<div class="error-message" style="color:orange">Validating...</div>
	{/if}
</div>
